import parsePhoneNumberFromString, { parsePhoneNumberWithError, CountryCode } from 'libphonenumber-js';
import { DEFAULT_COUNTRY_CODE } from '@vendasta/galaxy/utility/phone-utils';

export function formatPhoneNumber(value: string): string {
  const nonNumericPattern = /[^\d\s()+-]/;
  if (nonNumericPattern.test(value)) {
    return value;
  }

  try {
    const phoneNumber = parsePhoneNumberWithError(value, DEFAULT_COUNTRY_CODE);
    return `+${phoneNumber.countryCallingCode} ${phoneNumber.formatNational()}`;
  } catch {
    return value;
  }
}

export function splitPhoneNumber(phoneNumberString: string): { country: string; phoneNumber: string } {
  if (!phoneNumberString) {
    return { country: DEFAULT_COUNTRY_CODE, phoneNumber: '' };
  }

  try {
    const parsed = parsePhoneNumberFromString(phoneNumberString);

    if (!parsed || !parsed.nationalNumber) {
      console.warn('parsePhoneNumber returned invalid data for:', phoneNumberString, parsed);
      return { country: DEFAULT_COUNTRY_CODE, phoneNumber: phoneNumberString.replace(/[^\d]/g, '') };
    }

    return {
      country: parsed.country || DEFAULT_COUNTRY_CODE,
      phoneNumber: parsed.nationalNumber,
    };
  } catch (error) {
    console.warn('Failed to parse phone number:', phoneNumberString, error);
    return { country: DEFAULT_COUNTRY_CODE, phoneNumber: phoneNumberString.replace(/[^\d]/g, '') };
  }
}

export function combinePhoneNumber(country: string, phoneNumber: string): string {
  if (!phoneNumber) {
    return '';
  }

  try {
    const parsed = parsePhoneNumberFromString(phoneNumber, country as CountryCode);

    if (!parsed) {
      console.warn('Failed to parse phone number:', { country, phoneNumber });
      return '';
    }

    const formattedNumber = parsed.format('E.164');

    return formattedNumber;
  } catch (error) {
    console.warn('Failed to format phone number:', { country, phoneNumber }, error);
    return '';
  }
}
